import { Accordion } from "PFComponents/accordion/accordion";
import React from "react";
import { useTranslation } from "react-i18next";

import { FetchCategoryValues } from "../../edit_account.types";
import css from "../edit_account_page.module.scss";
import { CategoryAutoSelect, CategoryAutoSelectProps } from "./category_auto_select";

type CategoriesSectionProps = FetchCategoryValues;

export const CategoriesSection = ({ fetchCategoryValues }: CategoriesSectionProps): JSX.Element => {
  const { t } = useTranslation("saasAdmin");

  const categoriesProps: CategoryAutoSelectProps[] = [
    {
      label: t("accounts.account.categories.skill"),
      placeholder: t("accounts.account.categories.skillPlaceholder"),
      name: "skillCategories",
      fetchCategoryValues: (term: string) => fetchCategoryValues("skill", term)
    },
    {
      label: t("accounts.account.categories.brand"),
      placeholder: t("accounts.account.categories.brandPlaceholder"),
      name: "brandCategories",
      fetchCategoryValues: (term: string) => fetchCategoryValues("brand", term)
    },
    {
      label: t("accounts.account.categories.language"),
      placeholder: t("accounts.account.categories.languagePlaceholder"),
      name: "languageCategories",
      fetchCategoryValues: (term: string) => fetchCategoryValues("language", term)
    },
    {
      label: t("accounts.account.categories.qualification"),
      placeholder: t("accounts.account.categories.qualificationPlaceholder"),
      name: "qualificationCategories",
      fetchCategoryValues: (term: string) => fetchCategoryValues("qualification", term)
    }
  ];
  return (
    <div>
      <Accordion header={t("accounts.account.categories.header")}>
        <div className={css.sectionContainer}>
          {categoriesProps.map((categoryProps) => (
            <CategoryAutoSelect key={categoryProps.name} {...categoryProps} />
          ))}
        </div>
      </Accordion>
    </div>
  );
};
